import { sendAppsignalError, displayToast } from "../modules/utils";

class ProductDetail {
  constructor(node) {
    this.element = node;

    this.productLabelForm = this.element.querySelector(".js-product-detail-form");
    this.productLabelInput = this.element.querySelector(".js-product-detail-input");
    this.productLabelSlide = this.element.querySelector(".js-product-detail-label-slide");
    this.productLabelThumbnailSlide = this.element.querySelector(".js-product-detail-label-thumbnail-slide");
    this.loadingWrapper = this.element.querySelector(".js-content-wrapper");

    // It's possible to have a product page without a product label
    if (this.productLabelForm) {
      this.labelUrl = new URL(this.productLabelForm.action);

      this.initialize();
    }
  }

  initialize() {
    if (this.productLabelInput) {
      this.productLabelInput.addEventListener("change", () => {
        const formData = new FormData(this.productLabelForm);

        for (const pair of formData.entries()) {
          this.labelUrl.searchParams.set(pair[0], pair[1]);
        }

        this.fetchNewLabel();
      });
    }
  }

  fetchNewLabel() {
    this.loadingWrapper.classList.add("is-loading");

    fetch(this.labelUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        const { slideContent, thumbnailSlideContent } = data;

        this.productLabelSlide.innerHTML = slideContent;
        this.productLabelThumbnailSlide.innerHTML = thumbnailSlideContent;

        this.loadingWrapper.classList.remove("is-loading");
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "ProductDetail", {
          response: this.response,
        });
      });
  }
}

const productDetail = document.querySelector("[data-js='product-detail']");

if (productDetail) {
  new ProductDetail(productDetail);
}
